import React, { useState } from 'react'
import Module from '../../../layout/Module'
import { 
  Routes,
  Route
} from 'react-router-dom'
import NotFoundPage from '../../../NotFoundPage/NotFoundPage'
import List from './List/List'
import View from './View/View'
import AlertSaveButton from '../../../button/AlertSaveButton'
import { useSelector } from 'react-redux'
import DialogCurriculum from './Dialog/Dialog'

const Curriculum = () => {
  const permissions = useSelector((state) => state?.session?.permissions?.curriculum || {})
  const [modal, setModal] = useState(null)

  return (
    <Module moduleName='curriculum'>
      <Module.Header
        title='Curriculum'
        titleLink={'/dashboard/Curriculum'}
      >
        <div className='flex justify-end items-center gap-2'>
          { permissions?.created && (
            <AlertSaveButton
              submodule='Curriculum'
              icon='plus'
              title='Create'
              color='secondary'
              onDontSave={() => setModal({
                type: 'create',
                form: {}
              })}
            />
          )}
        </div>
      </Module.Header>
      <Module.Body>
        <Routes>
          <Route index element={<List onModal={setModal} />} />
          <Route path=':curriculumId/*' Component={View} />
          <Route
            path='*'
            element={
              <Module.BodyFullContainer className='flex justify-center items-center'>
                <NotFoundPage />
              </Module.BodyFullContainer>
            } 
          />
        </Routes>
      </Module.Body>
      { modal && (
        <DialogCurriculum
          show={!!modal}
          type={modal.type}
          data={modal.form}
          onClose={() => setModal(null)}
        />
      )}
    </Module>
  )
}

export default Curriculum;
